import { EditStrategyFormFields } from '../EditShared/types';

const numberOrUndefined = (value: unknown): number | undefined => {
  if (value === '' || value === null || value === undefined) {
    return undefined;
  }

  const parsed = Number(value);
  if (Number.isNaN(parsed)) {
    return undefined;
  }

  return parsed;
};

const numberOrZero = (value: unknown): number => {
  const parsed = Number(value);
  if (Number.isNaN(parsed)) {
    return 0;
  }

  return parsed;
};

const numberOrNull = (value: unknown): number | null => {
  if (value === '' || value === null || value === undefined) {
    return null;
  }

  const parsed = Number(value);
  if (Number.isNaN(parsed)) {
    return null;
  }

  return parsed;
};

export const toLocalInputDate = (value: Date | string | undefined): string => {
  if (!value) {
    return '';
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const normalizeEditValues = (values: EditStrategyFormFields): EditStrategyFormFields => {
  return {
    ...values,
    minSumma: numberOrZero(values.minSumma),
    recommendedAmount: numberOrUndefined(values.recommendedAmount),
    capacity: numberOrUndefined(values.capacity),
    estimatedProfit: numberOrUndefined(values.estimatedProfit),
    estimatedTradesPerWeek: numberOrUndefined(values.estimatedTradesPerWeek),
    maxInstrumentWeight: numberOrZero(values.maxInstrumentWeight),
    maxSignalWeight: numberOrUndefined(values.maxSignalWeight),
    leverage: numberOrZero(values.leverage),
    shortLeverage: numberOrNull(values.shortLeverage),
    rateShort: numberOrNull(values.rateShort),
    rateLong: numberOrNull(values.rateLong),
    codeDWH: String(values.codeDWH || ''),
    productPlanKO: String(values.productPlanKO || ''),
  };
};
